(() => {
  const normalize = (value) =>
    (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

  class SalutIngredientsHub extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-hub-input]');
      this.clearButton = this.querySelector('[data-hub-clear]');
      this.status = this.querySelector('[data-hub-status]');
      this.empty = this.querySelector('[data-hub-empty]');
      this.toggle = this.querySelector('[data-hub-toggle]');
      this.groups = Array.from(this.querySelectorAll('[data-hub-group]'));
      this.chips = Array.from(this.querySelectorAll('[data-hub-chip]'));
      this.labels = this.readJson('[data-hub-labels]');

      const index = this.readJson('[data-hub-index]');
      this.cards = Array.from(this.querySelectorAll('.salut-ping__item')).map((node) => {
        const handle = node.querySelector('[data-ping-open]')?.dataset.pingOpen.replace('SalutIngHub-', '');
        return { node, terms: normalize(index[handle]) };
      });

      this.plurals = new Intl.PluralRules(document.documentElement.lang || 'ro');
      this.kind = '';

      this.input.addEventListener('input', () => this.filter());
      this.clearButton.addEventListener('click', () => this.clear());
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.selectKind(chip)));
      this.toggle?.addEventListener('click', () => this.onToggle());
    }

    readJson(selector) {
      try {
        return JSON.parse(this.querySelector(selector).textContent);
      } catch (error) {
        return {};
      }
    }

    clear() {
      this.input.value = '';
      this.filter();
      this.input.focus();
    }

    selectKind(chip) {
      this.kind = chip.dataset.hubChip;
      this.chips.forEach((node) => {
        const active = node === chip;
        node.classList.toggle('salut-ihub__chip--active', active);
        node.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.filter();
    }

    onToggle() {
      const expanded = this.classList.toggle('salut-ihub--expanded');
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const label = this.toggle.querySelector('[data-hub-toggle-label]');
      if (label) label.textContent = expanded ? this.labels.less : this.labels.more;
    }

    filter() {
      const term = normalize(this.input.value).trim();
      const filtering = term !== '' || this.kind !== '';

      this.clearButton.hidden = this.input.value === '';
      this.classList.toggle('salut-ihub--filtering', filtering);

      let visible = 0;
      this.cards.forEach((card) => {
        const match = term === '' || card.terms.includes(term);
        card.node.hidden = !match;
        if (match) visible += 1;
      });

      this.groups.forEach((group) => {
        const inKind = this.kind === '' || group.dataset.hubGroup === this.kind;
        const hasCard = group.querySelector('.salut-ping__item:not([hidden])') !== null;
        group.hidden = !inKind || !hasCard;
      });

      if (this.kind !== '') {
        visible = this.groups
          .filter((group) => !group.hidden)
          .reduce((total, group) => total + group.querySelectorAll('.salut-ping__item:not([hidden])').length, 0);
      }

      this.empty.hidden = visible !== 0;
      if (this.toggle) this.toggle.hidden = filtering;
      this.renderStatus(term, visible);
    }

    renderStatus(term, count) {
      if (term === '') {
        this.status.hidden = true;
        return;
      }

      const raw = this.input.value.trim();
      const template =
        count === 0
          ? this.labels.no_results
          : this.labels[`results_${this.plurals.select(count)}`] || this.labels.results_other;

      this.status.textContent = (template || '').replace('{count}', count).replace('{term}', raw);
      this.status.classList.toggle('salut-ihub__status--empty', count === 0);
      this.status.hidden = false;
    }
  }

  if (!customElements.get('salut-ingredients-hub')) {
    customElements.define('salut-ingredients-hub', SalutIngredientsHub);
  }
})();
